import { render, staticRenderFns } from "./create-room.vue?vue&type=template&id=49e84e92&"
import script from "./create-room.vue?vue&type=script&lang=js&"
export * from "./create-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports